import validationLogicData from "../model/logic/validationLogicData.js"
import compareSum from "./validate/compareSum.js"
import emptyArray from "./validate/emptyArray.js"
import emptySubCollection from "./validate/emptySubCollection.js"
import emptyCollection from "./validate/emptyCollection.js"
import checkField from "./validate/checkField.js"
import noReferences from "./validate/noReferences.js"

// Guard operations, keyed by the `operation` name used in validationLogicData.
// Each returns { valid: boolean }. Add new generic operations here — never
// special-case an entity in this file.
const operations = {
    compareSum:         ({ target, condition, data })              => compareSum(target, condition, data),
    emptyArray:         ({ condition, data })                      => emptyArray(condition, data),
    checkField:         ({ condition, conditions, data })          => checkField(condition, data, conditions),
    emptyCollection:    ({ target, condition, data, getData })     => emptyCollection(target, condition, data, getData),
    emptySubCollection: ({ target, condition, data, getData })     => emptySubCollection(target, condition, data, getData),
    noReferences:       ({ target, condition, data, getData })     => noReferences(target, condition, data, getData)
}

// onFail is normally { title, msg }, but a few older configs pass a bare string.
const normaliseOnFail = (onFail) =>
    typeof onFail === 'string' ? { msg: onFail } : (onFail || {})

const runValidationLogic = async (entity, operation, data, getData) => {
    const config = validationLogicData?.[entity]?.[operation]

    // No rules configured for this entity/operation — nothing to block.
    if (!config?.length) return { valid: true, error: 'error.validation.generic' }

    for (const rule of config) {
        const handler = operations[rule.operation]

        if (!handler) {
            // Fail closed: an unknown operation means the intended guard is not
            // running, and silently allowing the delete is the worse outcome.
            console.error(`<runValidationLogic> unknown operation '${rule.operation}' on ${entity}.${operation}`)
            return { valid: false, error: 'error.validation.generic', title: 'error.validation.title' }
        }

        const result = await handler({
            target: rule.target,
            condition: rule.condition,
            conditions: rule.conditions,
            data,
            getData
        })

        if (!result?.valid) {
            const onFail = normaliseOnFail(rule.onFail)
            return {
                valid: false,
                error: onFail.msg || 'error.validation.generic',
                title: onFail.title || 'error.validation.title',
                count: result?.count
            }
        }
    }

    return { valid: true, error: 'error.validation.generic' }
}

export default runValidationLogic
